import axiosInstance from "@/api/axios-instance";

export async function updateFeatureFlags(professionalId: string) {
  const response = await axiosInstance.post(
    `/professional/${professionalId}/feature-flags`
  );

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update feature flags");
  }

  return response.data;
}
